import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import "./ProductGrid.css";

const ProductGrid = ({ products, loading, error, searchURL }) => {
  const [copiedMessage, setCopiedMessage] = useState(null); // State for copied message
  const [copiedProductId, setCopiedProductId] = useState(null); // Track which product's link was copied

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (products.length === 0) return <p>No deals found for this category.</p>;

  // Function to copy the shareable link
  const handleCopyLink = (asin) => {
    const shareableLink = `${window.location.origin}/product/${asin}`;
    navigator.clipboard.writeText(shareableLink).then(() => {
      setCopiedMessage("Link copied!"); // Show message
      setCopiedProductId(asin); // Set the product ID for which the link was copied
      setTimeout(() => {
        setCopiedMessage(null); // Hide message after 2 seconds
        setCopiedProductId(null); // Reset the product ID
      }, 2000);
    });
  };

  return (
    <div className="product-grid">
      {products.map((product) => (
        <div key={product.ASIN} className="product-tile">
          {/* Link to the product details page (image) */}
          <Link to={`/product/${product.ASIN}`} className="product-image-link">
            <img src={product.Image} alt={product.Title} className="product-image" />
          </Link>

          <div className="product-details">
            {/* Link to the product details page (title) */}
            <Link to={`/product/${product.ASIN}`} className="product-title-link">
              <h3 className="product-title">{product.Title}</h3>
            </Link>

            <p className="product-price">
              <span className="discounted-price">{product.Price} </span>
              <span className="original-price">{product.ActualPrice} </span>
              <span className="discount-percentage">{product.DiscountPercentage}%</span>
            </p>

            <div className="product-actions">
              <a
                href={product.DetailPageURL}
                target="_blank"
                rel="noopener noreferrer"
                className="product-link"
              >
                View on Amazon
              </a>

              {/* Copy Link Button */}
              <div className="copy-button-container">
                <button
                  className="copy-button"
                  onClick={() => handleCopyLink(product.ASIN)}
                  title="Copy link" // Tooltip on hover
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-files"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                  </svg>
                </button>
                {copiedMessage && copiedProductId === product.ASIN && (
                  <div className="copied-message">{copiedMessage}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* "Click here for more deals" tile */}
      {searchURL && (
        <div className="product-tile more-deals-tile">
          <div className="more-deals-content">
            <h3 className="more-deals-title">Want more deals?</h3>
            <p className="more-deals-text">Explore the full list of deals for this category.</p>
            <a
              href={searchURL}
              target="_blank"
              rel="noopener noreferrer"
              className="more-deals-button"
            >
              Click here for more deals
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;